import React from "react";
import { Helmet } from "react-helmet";
import ContentFetch from "../../components/Fetch/ContentFetch";
import ComponentList from "../../components/ComponentList/ComponentList";
import { Analytics } from "../../utilities";
import { PageSection } from "../../types";
import { API_PATH_START } from "../../constants";
import { cleanUrl } from "../../utilities";

type ListProps = {
  enableAbroadBanner: () => void;
  search?: string;
  isViewAll?: boolean;
};

const List: React.FunctionComponent<ListProps> = ({
  enableAbroadBanner,
  search,
  isViewAll = false,
}) => {
  const pathname = window.location.pathname;
  const parsedSearch = search ? new URLSearchParams(search) : undefined;
  const viewAllPathItems = window.location.href.split("viewall/")
  const viewAllPath = isViewAll
    ? viewAllPathItems[1] || undefined
    : undefined;

  return (
    <ContentFetch viewAllPath={viewAllPath?.split("/")[0]} onComplete={Analytics.pageViewList}>
      {(errors, screen) => {
        if (!screen || errors) {
          return null;
        }

        const dynamicHeaderValue = viewAllPath?.split("/")[1]?.replace(/-/g, " ").replace(/~/g, "-").replace(/\s+/g, " ").trim();


        const section = screen.sections?.[0] || {};
        const component: PageSection = {
          ...section,
          type: "grid",
          header: (isViewAll ? "View All - " : "") + (dynamicHeaderValue || section.header)
        };

        return (
          <React.Fragment>
            <Helmet>
              <title>
                {(component && `BBC Player | ${dynamicHeaderValue || component.name}`) || "BBC Player"}
              </title>
            </Helmet>

            <ComponentList
              components={[component]}
              extraProps={{ category: component.name }}
              enableAbroadBanner={enableAbroadBanner}
            />
          </React.Fragment>
        );
      }}
    </ContentFetch>
  );
};

export default List;
